module.exports = __webpack_public_path__ + "static/media/turmeric_getty_desktop.2d57fd2a.jpg";